// ================= Basic Component Model =================
export class BasicCompModel {
  constructor({ signal, pin, net }) {
    this.signal = signal || '';
    this.pin = pin || '';
    this.net = net || '';
  }
}